import Clipboard from 'clipboard'
import Popper from 'popper.js'
import Component from '../../lib/component'

export default class ClientHandbookArticleComponent extends Component {
    static selector () {
        return '.client-handbook-article'
    }

    constructor (opts) {
        super(opts)

        this.addFeatureTest({
            shareLinks: () => {
                if (!this.getArticleTooltipAnchorTwitter())
                    return false

                this.getArticleTooltipAnchorTwitter().href
                    = this.getArticleTooltipAnchorTwitterHref()

                return window
                    .getComputedStyle(this.getArticleTooltipAnchorTwitter())
                    .display !== 'none'
            }
        })

        this.Tooltip = null

        this.onCopyLinkBtnKeydown
            = this.onCopyLinkBtnKeydown.bind(this)

        this.onSocialMenuToggleBtnClick
            = this.onSocialMenuToggleBtnClick.bind(this)

        this.onSocialMenuToggleBtnKeydown
            = this.onSocialMenuToggleBtnKeydown.bind(this)

        this.onDocumentClick
            = this.onDocumentClick.bind(this)

        this.listen()
    }

    listen () {
        // Text Selection Tooltip
        if (this.getFeature('shareLinks')) {
            document.body
                .addEventListener('mouseup', e =>
                    this.onArticleTextSelection(e))

            document.body
                .addEventListener('mousedown', e =>
                    this.onArticleTextSelection(e))
        }

        if (!this.getSocialMenuToggleBtn() && !this.getCopyLinkBtn())
            return

        // Small Viewport Social Share Menu Toggle
        if (this.getSocialMenuToggleBtn()) {
            this.getSocialMenuToggleBtn()
                .addEventListener('click', this.onSocialMenuToggleBtnClick)

            this.getSocialMenuToggleBtn()
                .addEventListener('keydown', this.onSocialMenuToggleBtnKeydown)

            document.body
                .addEventListener('click', e =>
                    this.onDocumentClick(e))
        }

        // Clipboard detection
        if (!Clipboard.isSupported() || !this.getCopyLinkBtn())
            return this.getCopyLinkBtn()
                ? this.getCopyLinkBtn().remove()
                : null

        // Copy Article URL Button
        new Clipboard('.client-handbook-article-copy-link-btn')
            .on('error', e => console.warn(e))
            .on('success', e => {
                e.trigger.classList.add('success')

                setTimeout(() =>
                    e.trigger.classList.remove('success'), 3000)
            })

        this.getCopyLinkBtn()
            .addEventListener('keydown', this.onCopyLinkBtnKeydown)
    }

    onArticleTextSelection (e) {
        const isTooltipEvent = () => {
            const evtPath = []

            if (!e.target
                    || !e.target.parentElement
                    || !this.getArticleTooltip())
                return false

            let element = e.target

            while (element.parentElement) {
                evtPath.push(element)
                element = element.parentElement
            }

            return evtPath.indexOf(this.getArticleTooltip()) >= 0
        }

        const selection = document.getSelection()

        if (isTooltipEvent() && selection.anchorNode)
            return

        this.renderArticleTooltip(e)
    }

    onDocumentClick (e) {
        if (!this.getSocialMenuToggleBtn()
                || !this.getSocialMenuToggleBtn()
                    .getAttribute('aria-controls')
                || this.getSocialMenuToggleBtn()
                    .getAttribute('aria-expanded') !== 'true')
            return

        const socialMenuEl = this.el.querySelector(`#${
            this.getSocialMenuToggleBtn().getAttribute('aria-controls')}`)

        if (!socialMenuEl)
            return

        const isSocialMenuTarget = () => {
            const evtPath = []

            if (!e.target || !e.target.parentElement)
                return false

            let element = e.target

            while (element.parentElement) {
                evtPath.push(element)
                element = element.parentElement
            }

            return evtPath.indexOf(socialMenuEl) >= 0
        }

        if (!isSocialMenuTarget())
            return this.onSocialMenuToggleBtnClick(e)
    }

    onSocialMenuToggleBtnClick (e) {
        e.stopPropagation()

        if (!this.getSocialMenuToggleBtn())
            return

        const isExpanded = () => this.getSocialMenuToggleBtn()
            .getAttribute('aria-expanded') === 'true'

        this.getSocialMenuToggleBtn()
            .setAttribute('aria-expanded', !isExpanded())

        const labelCollapsed = this.getSocialMenuToggleBtn()
            .getAttribute('data-aria-label-collapsed')

        const labelExpanded = this.getSocialMenuToggleBtn()
            .getAttribute('data-aria-label-expanded')

        let label

        if (labelCollapsed && !isExpanded())
            label = labelCollapsed

        if (labelExpanded && isExpanded())
            label = labelExpanded

        if (label)
            this.getSocialMenuToggleBtn().setAttribute('aria-label', label)
    }

    onCopyLinkBtnKeydown (e) {
        if (e.keyCode === 32
                || (e.keyIdentifier || e.key || '').match(/^(enter)$/i))
            return this.getCopyLinkBtn().click()
    }

    onSocialMenuToggleBtnKeydown (e) {
        if (e.keyCode === 32
                || (e.keyIdentifier || e.key || '').match(/^(enter)$/i))
            return this.onSocialMenuToggleBtnClick(e)
    }

    getCopyLinkBtn () {
        return this.el
            .querySelector('.client-handbook-article-copy-link-btn')
    }

    getSocialMenuToggleBtn () {
        return this.el
            .querySelector('.client-handbook-article-social-menu-toggle-btn')
    }

    getArticleBlocks () {
        return this.el
            .querySelector('.client-handbook-article-blocks')
    }

    getArticleTooltip () {
        return this.el
            .querySelector('.client-handbook-article-tooltip')
    }

    getArticleTooltipAnchorTwitter () {
        return this.getArticleTooltip()
            ? this.getArticleTooltip()
                .querySelector('.client-handbook-article-tooltip-twitter')
            : null
    }

    getArticleTooltipAnchorTwitterHref (str = '') {
        const getUrl = (txt = '') => `https://twitter.com/intent/tweet?text=${
            encodeURIComponent(txt)}`

        const tweetTmpl = (txt = '') => `"${txt}" -@brooklynfoundry\n${
            window.location.host}${window.location.pathname}`

        const maxLength = 280 - tweetTmpl().length

        if (str.length <= maxLength)
            return getUrl(tweetTmpl(str))

        if ((str.indexOf('.') && maxLength + 1) <= maxLength)
            str = str.substring(0, str.indexOf('.'))
        else if ((str.indexOf('!') && maxLength + 1) <= maxLength)
            str = str.substring(0, str.indexOf('!'))
        else if ((str.indexOf('?') && maxLength + 1) <= maxLength)
            str = str.substring(0, str.indexOf('?'))
        else {
            str = str.substring(0, str.indexOf(' ', maxLength * 0.94))
            str = str.replace(/(,|:|;|-|–|—)$/g, '') + '...'
        }

        return getUrl(tweetTmpl(str))
    }

    renderArticleTooltip (e) {
        const selection = document.getSelection()

        const range = selection.anchorNode
            ? selection.getRangeAt(0)
            : ''

        const text = String(range)

        const isArticleTextSelection = () => {
            const evtPath = []

            if (!e.target || !e.target.parentElement)
                return false

            let element = e.target

            while (element.parentElement) {
                evtPath.push(element)
                element = element.parentElement
            }

            return evtPath.indexOf(this.getArticleBlocks()) >= 0
        }

        if (!text
                || !isArticleTextSelection()
                || !this.getArticleTooltipAnchorTwitterHref(text)
                || !this.getArticleTooltip()
                || !this.getArticleTooltipAnchorTwitter()
                || ((e.type === 'mousedown' || e.type === 'selectionchange')
                    && this.getArticleTooltip()
                    && this.getArticleTooltip().getAttribute('x-placement')))
            return this.Tooltip
                ? this.Tooltip.destroy()
                : null

        this.getArticleTooltipAnchorTwitter().href
            = this.getArticleTooltipAnchorTwitterHref(text)

        this.Tooltip = new Popper(range, this.getArticleTooltip(), {
            placement: this.getFeature('touch')
                ? 'bottom'
                : 'top'
        })
    }
}
